import { _axios } from "../../../Utils/Axios/axios";

export const verifySMS_Service = async (
  phone: number | string,
  code: string
) => {
  return _axios.post(
    "verify_sms",
    {
      phone,
      code,
    },
    {}
  );
};
